import "./ShapeFour.css";

export default function ShapeFour() {
  return <div className="shape-4"></div>;
}
